goog.provide('yext.entity.fields.ecl');
goog.provide('yext.entity.fields.ecl.EnhancedList');

goog.require('yext');
goog.require('yext.dialog');
goog.require('yext.location.ReferenceValueList');
goog.require('yext.storm.routesDEPRECATED');
goog.require('yext.textfield.TextField');
goog.require('yext.textfield');
goog.require('yext.location.helpers');

/**
 * @param {!jQuery} $ctx Element context for this field
 * @constructor
 * @author MattJS (matt@yext.com)
 */
yext.entity.fields.ecl.EnhancedList = function($ctx) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-entity-enhanced-list-field').addBack()
    .filter('.js-entity-enhanced-list-field');
  this.$fieldValue = this.$field.find('.js-field-value');

  this.publishDialogTemplate = this.$field.find('.js-publish-ecl-dialog-template').html();
  this.labelDisplayTemplate = this.$field.find('.js-label-display-template').html();

  this.fieldData = this.$field.data();
  this.timestamp = this.fieldData['timestamp'];

  this.label = yext.textfield.createWithUsageType($ctx, this.getFieldId());
  this.associated = yext.location.ReferenceValueList.field($ctx.find('.js-reference-value-list-field'));

  this.setFieldValue();
  this.bind();
};

/**
 * Saves the state of the field
 */
yext.entity.fields.ecl.EnhancedList.prototype.saveState = function() {
  this.label.saveValue();
  this.associated.storeValue();
};

/**
 * Get the field id for the field
 */
yext.entity.fields.ecl.EnhancedList.prototype.getFieldId = function() {
  return this.fieldData['fieldId'];
};

/**
 * Get the list type, which corresponds to EnhancedListsView.Type#getSlug
 */
yext.entity.fields.ecl.EnhancedList.prototype.getListType = function() {
  return this.fieldData['listType'];
};

/**
 * Maps the type slug to com.yext.enhancedlists.EnhancedList.Type enum
 */
yext.entity.fields.ecl.EnhancedList.prototype.getMappedListType = function() {
  return yext.entity.fields.ecl.EnhancedList.TYPE_MAP[this.getListType()];
};

yext.entity.fields.ecl.EnhancedList.TYPE_MAP = {
  'menus': 'Menu',
  'products': 'ProductList',
  'events': 'Calendar',
  'bios': 'Bios',
};

yext.entity.fields.ecl.EnhancedList.MAX_LIST_COUNT = 20;

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.entity.fields.ecl.EnhancedList.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getData()));
};

/**
 * Get list data for saving
 */
yext.entity.fields.ecl.EnhancedList.prototype.getData = function() {
  return {
    'id': this.getFieldId(),
    'label': this.label.coreData(),
    'associated': this.associated.getData(),
    'timestamp': this.timestamp,
  };
};

/**
 * Bind field events
 */
yext.entity.fields.ecl.EnhancedList.prototype.bind = function() {
  var self = this;

  $(this.label).on('update.textField', function() {
    self.onUpdate();
  });

  $(this.associated).on('updated', function() {
    self.onUpdate();
    // Bind any new hidden lists
    self.bindHiddenBadges();
  });

  this.bindHiddenBadges();
};

/**
 * Bind the hidden list badges
 */
yext.entity.fields.ecl.EnhancedList.prototype.bindHiddenBadges = function() {
  var self = this;
  this.$ctx.find('.js-hidden-list-badge').each(function() {
    self.bindShowListBadge($(this));
  });
};

/**
 * Bind the 'Show list' button for hidden lists
 */
yext.entity.fields.ecl.EnhancedList.prototype.bindShowListBadge = function($badge) {
  var $option = $badge.closest('.js-ecl-option');
  var self = this;
  var listId = $option.data('listId');

  $badge.off('click').on('click', function(e) {
    e.stopPropagation();
    $('.js-tooltip-publish-'+ self.getListType() + ' .js-publish-list').off().click(function() {
      window.hideContextualHelp();
      self.showList(listId);
    });
  });

  $badge.contextualHelp({width: 160});
};

/**
 * Fetch the number of associated listings and then show a dialog to confirm 'publishing' the list
 *
 * @param {number} listId
 */
yext.entity.fields.ecl.EnhancedList.prototype.showList = function(listId) {
  var self = this;
  this.fetchAssociatedLocationCount(listId, function(count) {
    self.showPublishDialog(listId, count);
  }, function() {
    self.errorShowingList();
  });
};

/**
 * Error message for 'show' operation
 */
yext.entity.fields.ecl.EnhancedList.prototype.errorShowingList = function() {
  // TRANSLATORS: 'list' is a Yext Enhanced Content List
  yext.dialog.showErrorDialog(yext.msg('Error showing list'));
};

/**
 * Get the number of listings that have this list associated
 * @param {number} listId
 * @param {function()} cb Triggered after the ajax call returns with a count
 * @param {function()} error
 */
yext.entity.fields.ecl.EnhancedList.prototype.fetchAssociatedLocationCount = function(listId, cb, error) {
  var data = {
    'ids': [listId],
    'type': this.getMappedListType(),
  };

  $.ajax({
    url: yext.storm.routesDEPRECATED.EnhancedLists.countAssociatedLocations(),
    data: data,
    success: function(response) {
      if (response && !isNaN(response['total'])) {
        cb(response['total']);
      } else {
        error();
      }
    },
    error: function() {
      error();
    },
  });
};

/**
 * Show the publish list dialog and bind its actions
 * @param {number} listId
 * @param {number} count The number of locations with this list associated
 */
yext.entity.fields.ecl.EnhancedList.prototype.showPublishDialog = function(listId, count) {
  var self = this;
  var $dialog = this.buildPublishDialog(count);
  $dialog.find('.js-do-publish').click(function() {
    $dialog.dialog('close');
    self.publishList(listId);
  });
  $dialog.find('.js-cancel-publish').click(function() {
    $dialog.dialog('close');
  });
  $dialog.dialog('open');
};

/**
 * Makes a 'Hidden' list 'published'
 * @param {number} listId
 */
yext.entity.fields.ecl.EnhancedList.prototype.publishList = function(listId) {
  var self = this;

  yext.dialog.showProgressDialog(yext.msg('Showing...'));

  $.ajax({
    url: yext.storm.routesDEPRECATED.EnhancedLists.publishLists(),
    data: {
      'publish': true,
      'ids': [listId],
      'type': this.getMappedListType(),
    },
    method: 'POST',
    success: function(result) {
      if (result && result.result === 'success') {
        self.removeHiddenBadge(listId);
      } else if (result && result.reason) {
        yext.dialog.showErrorDialog(result.reason);
      } else {
        self.errorShowingList();
      }
    },
    error: function() {
      self.errorShowingList();
    },
  }).always(function() {
    yext.dialog.hideProgressDialog();
  });
};

/**
 * Removes the 'Hidden' badge from a recently published list
 * @param {number} listId
 */
yext.entity.fields.ecl.EnhancedList.prototype.removeHiddenBadge = function(listId) {
  var item = this.associated.getItem(listId);
  var $label = $(item.model.label);

  // Remove the hidden badge and set the label back
  $label.find('.js-hidden-list-badge').remove();
  item.model.setLabel($label.prop('outerHTML'));
  item.render();
};

/**
 * Build the publish dialog by getting the correct copy based upon listType
 * @param {number} count The number of locations associated with a particular list
 */
yext.entity.fields.ecl.EnhancedList.prototype.buildPublishDialog = function(count) {
  var message;
  var title;

  switch (this.getListType()) {
    case 'menus':
      if (count === 0) {
        message = yext.msg(
          'This menu is hidden.<br><br>When you show this menu, it will appear on your listings immediately.');
      } else {
        message = yext.msgn(
          'This menu is associated with 1 location.<br><br>When you show it, it will appear on the listings for that location.',
          'This menu is associated with {0} locations.<br><br>When you show it, it will appear on the listings for those locations.',
          count);
      }
      title = yext.msg('Show menu');
      break;
    case 'events':
      if (count === 0) {
        message = yext.msg(
          'This calendar is hidden.<br><br>When you show this calendar, it will appear on your listings immediately.');
      } else {
        message = yext.msgn(
          'This calendar is associated with 1 location.<br><br>When you show it, it will appear on the listings for that location.',
          'This calendar is associated with {0} locations.<br><br>When you show it, it will appear on the listings for those locations.',
          count);
      }
      title = yext.msg('Show calendar');
      break;
    default:
      if (count === 0) {
        message = yext.msg(
          'This list is hidden.<br><br>When you show this list, it will appear on your listings immediately.');
      } else {
        message = yext.msgn(
          'This list is associated with 1 location.<br><br>When you show it, it will appear on the listings for that location.',
          'This list is associated with {0} locations.<br><br>When you show it, it will appear on the listings for those locations.',
          count);
      }
      title = yext.msg('Show list');
      break;
  }

  var $dialog = $(this.publishDialogTemplate.replace('#MESSAGE', message));

  return $dialog.dialog({
    autoOpen: true,
    modal: true,
    draggable: false,
    resizable: false,
    title: title,
    width: 355,
    close: function() {
      $dialog.dialog('destroy');
    },
  });
};

/**
 * Called when any part of the field is updated
 */
yext.entity.fields.ecl.EnhancedList.prototype.onUpdate = function() {
  this.setFieldValue();
  this.message('updated');
};

/**
 * Trigger a message that is broadcast with the instance as context
 * @param
 */
yext.entity.fields.ecl.EnhancedList.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the state of the field to a stored state
 */
yext.entity.fields.ecl.EnhancedList.prototype.reset = function() {
  this.label.reset();
  this.associated.reset();
};

/**
 * Set the value of the field
 */
yext.entity.fields.ecl.EnhancedList.prototype.set = function(field) {
  this.label.set(field['label']);
  this.associated.set(field['associated']);
  this.timestamp = field['timestamp'];
};

/**
 * @return {boolean} True if the field is empty
 */
yext.entity.fields.ecl.EnhancedList.prototype.isEmpty = function() {
  return (this.label.isEmpty() || this.labelIsDefault()) && this.associated.isEmpty();
};

/**
 * @return {boolean} True if the label is equal to its default
 */
yext.entity.fields.ecl.EnhancedList.prototype.labelIsDefault = function() {
  return this.label.value() == this.fieldData['labelDefault'];
};

/**
 * Renders the display mode. $ctx must contain the display mode
 */
yext.entity.fields.ecl.EnhancedList.prototype.getDisplayValue = function() {
  if (this.isEmpty()) {
    return yext.location.helpers.emptyFieldMessage();
  } else {
    var html = '';
    html += this.labelDisplayTemplate.replace('#LABEL', this.label.viewMarkup());
    if (!this.associated.isEmpty()) {
      html += this.associated.getDisplayValue();
    }
    return html;
  }
};

/**
 * Render the display mode
 */
yext.entity.fields.ecl.EnhancedList.prototype.renderDisplay = function() {
  this.$ctx.find('.enhancedLists-display').empty().append(this.getDisplayValue());
  // Bind the display hidden list badges
  this.bindHiddenBadges();
};
